import { CHAT_UPLOAD_LIMITS } from "@/validations/chat";

export const MAX_NATIVE_IMPORT_BYTES = 128 * 1024 * 1024;
export function nativeMediaLimit(mimeType: string) {
  return mimeType.startsWith("video/")
    ? CHAT_UPLOAD_LIMITS["message-video"].maxBytes
    : CHAT_UPLOAD_LIMITS["message-image"].maxBytes;
}
export function assertNativeMediaSize(
  size: number,
  mimeType: string,
  total = 0,
) {
  if (!Number.isSafeInteger(size) || size <= 0)
    throw new Error(
      "Could not determine the selected file size. Try downloading it to your device first.",
    );
  if (size > nativeMediaLimit(mimeType))
    throw new Error(
      `Selected ${mimeType.startsWith("video/") ? "video" : "image"} is too large. Choose a smaller file.`,
    );
  if (total + size > MAX_NATIVE_IMPORT_BYTES)
    throw new Error("Select fewer files at once (128 MB total limit).");
  return total + size;
}
